const getters = {
  dict: state => state.app.dict,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  staffId: state => state.user.staffId,
  staffName: state => state.user.staffName,
  staffDepartment: state => state.user.staffDepartment,
  contractCount: state => state.user.contractCount,
  roles: state => state.user.roles,
  permissionList: state => state.permission.permissionList,
  accountTypes: state => state.permission.accountTypes,
  currentAccount: state => state.permission.currentAccount,
  routes: state => state.permission.routes,
  company_info: state => state.user.company_info,
  subProjectInfo: state => state.user.subProjectInfo,
  accessRecord: state => state.permission.accessRecord
}
export default getters
